<template>
  <div class="row justify-content-center">
    <div class="col-sm-12">
      <form ref="form" class="needs-validation" @submit.prevent="save">
        <div v-if="title" class="my-3 text-left w-100">
          <h3 class="d-inline-block mr-4">{{ title }}</h3>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-3">
            <label class="control-label">Fecha</label>
            <el-date-picker
              v-model="formData.date"
              v-validate="modelValidations.date"
              align="center"
              :editable="false"
              format="dd-MM-yyyy"
              name="date"
              class="w-100"
              placeholder="Ingrese una fecha (*)"
              suffix-icon="fas fa-calendar-alt"
              type="date"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>

            <small v-show="date.invalid" class="text-danger">
              {{ getError('date') }}
            </small>
          </div>

          <div class="col-sm-12 col-md-9">
            <label class="control-label">Descripción</label>
            <el-input
              v-model="formData.comment"
              v-validate="modelValidations.comment"
              :autosize="{ minRows: 5 }"
              name="comment"
              placeholder="Ingrese observaciones sobre la visita al lote"
              suffix-icon="fas fa-boxes"
              type="textarea"
            >
            </el-input>

            <small v-show="comment.invalid" class="text-danger">
              {{ getError('comment') }}
            </small>
          </div>

          <div class="col-sm-12 text-right mt-2">
            <base-button class="base-button" native-type="submit" size="sm" type="success">
              <template v-if="formData.id"> <i class="fas fa-save mr-1"></i>&nbsp;Guardar Observación </template>
              <template v-else> <i class="fas fa-plus mr-1"></i>&nbsp;Agregar Observación </template>
            </base-button>
            <base-button v-if="formData.id" class="base-button" size="sm" type="danger" @click="reset">
              Cancelar
            </base-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { DatePicker } from 'element-ui';
import { mapFields } from 'vee-validate';

export default {
  components: {
    [DatePicker.name]: DatePicker,
  },

  props: {
    title: {
      type: String,
      default: 'Observaciones',
    },
  },

  data() {
    return {
      validated: false,
      formData: {
        date: null,
        comment: null,
        id: null,
      },

      modelValidations: {
        comment: {
          required: true,
        },

        date: {
          required: true,
        },
      },
    };
  },

  computed: {
    ...mapFields(['date', 'comment']),
  },

  methods: {
    edit(comment) {
      this.reset();
      this.formData.date = comment.date;
      this.formData.comment = comment.body;
      this.formData.id = comment.id;
    },

    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    save() {
      this.firstFormSubmit().then((valid) => {
        if (valid) {
          const comment = {
            date: this.formData.date,
            body: this.formData.comment,
            id: this.formData.id,
          };
          this.$emit('save', comment);
        }
      });
    },

    clean() {
      this.formData.date = null;
      this.formData.comment = null;
      this.formData.id = null;
      this.validated = false;
      this.errors.clear();
      this.$validator.reset();
    },

    reset() {
      this.$refs.form.reset();
      this.clean();
    },

    getError(name) {
      return this.errors.first(name);
    },

    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
  },
};
</script>
